import axios from "axios";
import { baseUrl } from '../../config/clientsConfig'

export const DasboardService={
fetchDealForToday : (userRole, selectedTeamId, bodTeamId) => {
  console.log(`bodId: ${bodTeamId} userRole: ${userRole}`)
  let Url = ""; 
  if (userRole === "Admin" || userRole === "CMO") {
    Url = `${baseUrl}/analytics/dealForToday?booking=tzT2qiCM1ZJoppfd6l2A&booked=Q9JZE1p3V8dahjH8eMwl&registration=lu8FY04HlUM7wtuLG3wd&registered=OeC8MZqNykSosVgiPIGx`;
  } else if (userRole === "MD" ) {
    Url = `${baseUrl}/analytics/dealForToday?booking=tzT2qiCM1ZJoppfd6l2A&booked=Q9JZE1p3V8dahjH8eMwl&registration=lu8FY04HlUM7wtuLG3wd&registered=OeC8MZqNykSosVgiPIGx&teamDocId=${selectedTeamId}`;
  } else if (userRole === "BOD"){
  console.log(`BOD Url: ${Url}`)

    Url = `${baseUrl}/analytics/dealForToday?booking=tzT2qiCM1ZJoppfd6l2A&booked=Q9JZE1p3V8dahjH8eMwl&registration=lu8FY04HlUM7wtuLG3wd&registered=OeC8MZqNykSosVgiPIGx&teamDocId=${bodTeamId}`
  }
  console.log(`url: ${Url}`)
  return axios.get(Url);
},
 getTopSellingProperty : (registeredPlot) => {
  console.log(`registeredPlot: ${registeredPlot}`)
  const url = `${baseUrl}/topSellingProperty?registered=${registeredPlot}`;
  return axios.get(url);
 },
  getMonthlyTargetByTeam : (selectedMonth, currentYear) => {
    const url = `${baseUrl}/monthlyTargetByTeam?month=${selectedMonth}&year=${currentYear}`;
    return axios.get(url);
  },
  getMonthlyTargetValue : (selectedMonth, currentYear) => {
    const url = `${baseUrl}/monthlyTargetvalue?month=${selectedMonth}&year=${currentYear}`;
    return axios.get(url);
  },
  getTeamWiseTarget : (selectedMonth, currentYear) => {
    const url = `${baseUrl}/teamWiseTarget?month=${selectedMonth}&year=${currentYear}`;
    return axios.get(url);
  },
  postTargetValue : (targetValue) => {
    const url = `${baseUrl}/createMonthlyTarget`;
    return axios.post(url, { targetValue });
  },

}
